import { computed, defineComponent, PropType } from 'vue';
import { ExclusiveUi } from '@/fairplayer/primary/marketplace/Exclusive.ui';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'LiveAuctionBidsCard',

  props: {
    exclusives: {
      type: Array as PropType<ExclusiveUi[]>,
      required: true,
    },
  },

  setup(props) {
    const { t } = useI18n();

    const bids = computed(() => props.exclusives.reduce((total, exclusive) => exclusive.auctionLot!.bids?.length + total, 0));

    return {
      bids,
      t,
    };
  },
});
